module.exports = __webpack_public_path__ + "static/media/WEB22.4c1fb41c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB22.jpg
// module id = 92
// module chunks = 0